import 'maplibre-gl/dist/maplibre-gl.css';
import { setDateTimeLocalization } from '@racemap/utilities/functions/datetime';
import { ConfigProvider } from 'antd';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { EventsOverviewPage } from 'src/components/EventsOverview/EventsOverviewPage';
import { antdConfig } from 'src/lib/theme';

setDateTimeLocalization();

const container = document.getElementById('root');
if (container == null) throw new Error('Could not find root element');

createRoot(container).render(
  <StrictMode>
    <ConfigProvider {...antdConfig}>
      {/* only for useURLStates, the page has no routes */}
      <BrowserRouter>
        <EventsOverviewPage />
      </BrowserRouter>
    </ConfigProvider>
  </StrictMode>,
);

// ponytail: an embedding page (go.racemap.com) sizes its iframe to this height, so only it scrolls.
// Body, not scrollHeight: scrollHeight never drops below the iframe height, so it could not shrink.
if (window.self !== window.top) {
  new ResizeObserver(() =>
    window.parent.postMessage(
      {
        type: 'racemap-events-height',
        height: Math.ceil(document.body.getBoundingClientRect().height),
      },
      '*',
    ),
  ).observe(document.body);
}
